import { __rest, __assign } from './../../external_lib/tslib/tslib.es6.js';
import React__default from 'react';
import classNames from './../../external_lib/classnames/index.js';
import styles from '../../components/base/HorizonTour/index.module.scss.js';
import btnStyles from '../../components/base/HorizonButton/index.module.scss.js';
import AntTour from './../../external_lib/antd/es/tour/index.js';
function HorizonTour(_a) {
  var _b, _c;
  var className = _a.className,
    restProps = __rest(_a, ["className"]);
  return React__default.createElement(AntTour, __assign({}, restProps, {
    rootClassName: classNames(styles.horizonTour, className),
    gap: {
      radius: 4
    },
    steps: (_c = (_b = restProps === null || restProps === void 0 ? void 0 : restProps.steps) !== null && _b !== void 0 ? _b : []) === null || _c === void 0 ? void 0 : _c.map(function (step) {
      var _a, _b;
      return __assign(__assign({}, step), {
        nextButtonProps: __assign({
          className: btnStyles.horizonButton
        }, (_a = step.nextButtonProps) !== null && _a !== void 0 ? _a : {}),
        prevButtonProps: __assign({
          className: btnStyles.horizonButton
        }, (_b = step.prevButtonProps) !== null && _b !== void 0 ? _b : {})
      });
    }),
    indicatorsRender: function (current, total) {
      return React__default.createElement("span", {
        className: "text-xs text-up-black-40 py-2 inline-block"
      }, current + 1, " / ", total);
    }
  }));
}
export { HorizonTour as default };
//# sourceMappingURL=index.js.map
